import {Action, applyMiddleware, createStore} from 'redux';
import * as _ from 'lodash';
import thunk, {ThunkAction} from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension/logOnlyInProduction';
import RootReducer, {GlobalApplicationState} from '~/redux/reducers/RootReducer';

export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    GlobalApplicationState,
    unknown,
    Action<string>
>;

// Enable Chrome Dev Tools and Thunk Middleware
const composeEnhancers = composeWithDevTools({trace: true});
const enhancer = composeEnhancers(applyMiddleware(thunk));

export const store = createStore(RootReducer, enhancer);
